import { WSFilter } from "@wingspanhq/fe-component-library";
import {
  ICustomField,
  WSDataTypes
} from "@wingspanhq/payments/dist/interfaces";
import { useHistory } from "react-router-dom";
import { toURLQuerySearch } from "../../shared/hooks/useUrlQuery";

export const PAYEES_ROOT_PATH = "/member/payees";

export const PAYEES_LIST_PATH = PAYEES_ROOT_PATH + "";
export const PAYEES_SEARCH_PATH = PAYEES_ROOT_PATH + "/search";
export const PAYEES_ALL_PATH = PAYEES_ROOT_PATH + "/all";
export const PAYEES_NOT_SIGNED_UP_PATH = PAYEES_ROOT_PATH + "/not-signed-up";
export const PAYEES_COMPLETE_PATH = PAYEES_ROOT_PATH + "/complete";
export const PAYEES_INCOMPLETE_PATH = PAYEES_ROOT_PATH + "/incomplete";
export const PAYEES_ARCHIVED_PATH = PAYEES_ROOT_PATH + "/archived";

export const PAYEES_DETAILS_ROUTE = PAYEES_ROOT_PATH + "/:payeeId";
export const PAYEES_DETAILS_REQUIREMENTS_ROUTE =
  PAYEES_DETAILS_ROUTE + "/requirements";

export const PAYEES_REQUIREMENT_DETAILS_ROUTE =
  PAYEES_DETAILS_ROUTE + "/requirement/:requirementId";

export const PAYEES_DETAILS_EDIT_INFORMATION_ROUTE =
  PAYEES_DETAILS_ROUTE + "/edit/tax-information";

export const PAYEES_DETAILS_ENGAGEMENT_DETAILS_ROUTE =
  PAYEES_DETAILS_ROUTE + "/engagement/:engagementId";

export const PAYEES_DETAILS_HISTORY_ROUTE = PAYEES_DETAILS_ROUTE + "/history";

export const PAYEES_DETAILS_ENGAGEMENT_HISTORY_ROUTE =
  PAYEES_DETAILS_ROUTE + "/engagement/:engagementId/history";

export const PAYEES_DETAILS_ENGAGEMENT_RATE_CARD_ROUTE =
  PAYEES_DETAILS_ROUTE + "/engagement/:engagementId/rateCard/:rateCardId";

export const PAYEES_ENGAGEMENTS_LIST_PATH = PAYEES_ROOT_PATH + "/engagements";
export const PAYEES_ENGAGEMENTS_DETAILS_PATH =
  PAYEES_ENGAGEMENTS_LIST_PATH + "/:engagementId";

export const buildPath = (path: string, value: string, param: string) => {
  return path.replace(`:${param}`, value);
};

export const buildPayeeDetailsPath = (payeeId: string) => {
  return buildPath(PAYEES_DETAILS_ROUTE, payeeId, "payeeId");
};

export const buildPayeeDetailsRequirementsPath = (payeeId: string) => {
  return buildPath(PAYEES_DETAILS_REQUIREMENTS_ROUTE, payeeId, "payeeId");
};

export const useGoToPayeeDetails = () => {
  const history = useHistory();
  return (payeeId: string, payerId?: string) => {
    history.push({
      pathname: buildPayeeDetailsPath(payeeId),
      search: payerId ? toURLQuerySearch({ payerId }) : undefined
    });
  };
};

export const useGoToPayeeDetailsRequirements = () => {
  const history = useHistory();
  return (payeeId: string, payerId?: string) => {
    history.push({
      pathname: buildPayeeDetailsRequirementsPath(payeeId),
      search: payerId ? toURLQuerySearch({ payerId }) : undefined
    });
  };
};

export const buildPayeeEditTaxInfoPath = (payeeId: string) => {
  return buildPath(PAYEES_DETAILS_EDIT_INFORMATION_ROUTE, payeeId, "payeeId");
};

export const buildPayeeHistoryPath = (payeeId: string) => {
  return buildPath(PAYEES_DETAILS_HISTORY_ROUTE, payeeId, "payeeId");
};

export const buildEngagementHistoryPath = (
  payeeId: string,
  engagementId: string
) => {
  return buildPath(
    PAYEES_DETAILS_ENGAGEMENT_HISTORY_ROUTE,
    payeeId,
    "payeeId"
  ).replace(":engagementId", engagementId);
};

export const buildEngagementDetailsPath = (engagementId: string) => {
  return buildPath(
    PAYEES_ENGAGEMENTS_DETAILS_PATH,
    engagementId,
    "engagementId"
  );
};

export const useGoToEngagementDetails = () => {
  const history = useHistory();

  return (payeeId: string, engagementId: string, payerId?: string) => {
    history.push({
      pathname: buildPayeeDetailsEngagementDetailsPath(payeeId, engagementId),
      search: payerId ? toURLQuerySearch({ payerId }) : undefined
    });
  };
};

export const buildPayeeDetailsEngagementDetailsPath = (
  payeeId: string,
  engagementId: string
) => {
  return PAYEES_DETAILS_ENGAGEMENT_DETAILS_ROUTE.replace(
    ":payeeId",
    payeeId
  ).replace(`:engagementId`, engagementId);
};

export const buildEngagementRateCardPath = (
  payeeId: string,
  engagementId: string,
  rateCardId: string
) => {
  return PAYEES_DETAILS_ENGAGEMENT_RATE_CARD_ROUTE.replace(":payeeId", payeeId)
    .replace(":engagementId", engagementId)
    .replace(":rateCardId", rateCardId);
};

export const customFieldsToFilters = (
  customFields: ICustomField[]
): WSFilter[] => {
  return customFields.map(field =>
    field.type === WSDataTypes.Boolean
      ? {
          name: field.key,
          title: `${field.name} (custom field)`,
          type: "checkbox",
          options: [
            {
              label: "Yes",
              name: "true"
            },
            {
              label: "No",
              name: "false"
            }
          ],
          titleInLabel: true
        }
      : {
          name: field.key,
          title: `${field.name} (custom field)`,
          type: "input",
          titleInLabel: true
        }
  );
};
